import React from 'react';
import StudentSidebar from './StudentSidebar';
import '../pages/StudentDashboard.css';

function StudentLayout({ children, activeTab, unreadCount = 0, sidebarProps }) {
  return (
    <div className="stu-dashboard-wrapper">
      <StudentSidebar activeTab={activeTab} unreadCount={unreadCount} {...(sidebarProps || {})} />
      <main className="stu-main-content">
        {children}
      </main>
    </div>
  );
}

export default StudentLayout;
